const port = 5500;
// const port = 4000;
export const server_address = `http://server.woodenpickaxe.com:${port}`;
// export const server_address = `http://localhost:${port}`;
export const websocket_address = `ws://server.woodenpickaxe.com:${port}`;
// export const websocket_address = `ws://localhost:${port}`;
export const domainName = "averysecretplace.woodenpickaxe.com";

//s